// extracted by mini-css-extract-plugin
export var askAiIcon = "_pm-9";
export var container = "_pm-0";
export var groupSeparator = "_pm-a";
export var highlight = "_pm-4";
export var resultIcon = "_pm-5";
export var resultItem = "_pm-7";
export var resultSubtitle = "_pm-3";
export var resultTitle = "_pm-2";
export var resultsList = "_pm-1";
export var searchGroup = "_pm-6";
export var selected = "_pm-8";